import { render } from "./OrgUnitGoals.vue?vue&type=template&id=43dfaee8&scoped=true"
import script from "./OrgUnitGoals.vue?vue&type=script&lang=js"
export * from "./OrgUnitGoals.vue?vue&type=script&lang=js"

import "./OrgUnitGoals.vue?vue&type=style&index=0&id=43dfaee8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43dfaee8"]])

export default __exports__